// endpoints
import * as skuEndPoints from "../constants/endpoints/sku";
// axios
import axios from "../axios/axios";

export const getSkuCategories = (filters) => {
  return axios({
    url: skuEndPoints.getSkuCategories,
    method: "GET",
    params: filters,
  });
};

export const getSkuSubCategories = (categoryId) => {
  return axios({
    url: skuEndPoints.getSkuSubCategories.replace(":categoryId", categoryId),
    method: "GET",
  });
};

export const getAllSkuBrandsGivenSkuCategoryId = (categoryId) => {
  return axios({
    url: skuEndPoints.getAllSkuBrandsGivenSkuCategoryId,
    method: "GET",
    params: { categoryId },
  });
};

export const getAllSkus = (params) => {
  return axios({
    url: skuEndPoints.getAllSkus,
    method: "GET",
    params,
  });
};

export const getSkuDetails = (skuId, params) => {
  return axios({
    url: skuEndPoints.getSkuDetails.replace(":skuId", skuId),
    method: "GET",
    params,
  });
};

export const checkSkusMatchingCar = (skuIdList, carId) => {
  return axios({
    url: skuEndPoints.checkSkusMatchingCar,
    method: "POST",
    data: { carId, skuIdList },
  });
};

export const getSkuNames = () => {
  return axios({
    url: skuEndPoints.GET_SKU_NAMES,
    method: "GET",
  });
};

export const getAllMarketplaceSupplierPricesForSku = (skuId) => {
  return axios({
    url: `${skuEndPoints.getAllMarketplaceSupplierPricesForSku}/${skuId}`,
    method: "GET",
  });
};

export const matchSkuPriceTiering = (skuId, data) => {
  return axios({
    url: skuEndPoints.MATCH_SKU_PRICE_TIERING.replace(":skuId", skuId),
    method: "POST",
    data,
  });
};

export const requestQuantityForExistingSku = (data) => {
  return axios({
    url: skuEndPoints.requestQuantityForExistingSku,
    method: "POST",
    data,
  });
};

export const requestNewSku = (data) => {
  return axios({
    url: skuEndPoints.requestNewSku,
    method: "POST",
    data,
  });
};

export const getSkuDetailsForRequestedSkus = () => {
  return axios({
    url: skuEndPoints.getSkuDetailsForRequestedSkus,
    method: "GET",
  });
};

export const getSkuBrands = (params) => {
  return axios({
    url: skuEndPoints.getSkuBrands,
    method: "GET",
    params,
  });
};

export const getAllSkuOriginList = () => {
  return axios({
    url: skuEndPoints.getAllSkuOriginList,
    method: "GET",
  });
};

export const getSubstituteSkuList = (skuId, mechanicId) => {
  return axios({
    url: skuEndPoints.getSubstituteSkuList
      .replace(":skuId", skuId)
      .replace(":mechanicId", mechanicId),
    method: "GET",
  });
};

export const getRelevantSkuList = (skuId, mechanicId) => {
  return axios({
    url: skuEndPoints.getRelevantSkuList
      .replace(":skuId", skuId)
      .replace(":mechanicId", mechanicId),
    method: "GET",
  });
};

export const createSkuRepricingRequest = (data) => {
  return axios({
    url: skuEndPoints.createSkuRepricingRequest,
    method: "POST",
    data,
  });
};

export const exportPriceListsAsPdf = (params) => {
  return axios({
    url: skuEndPoints.exportPriceListsAsPdf,
    method: "GET",
    params,
  });
};

export const getAllSkuSubCategoriesNotPaginated = (params) => {
  return axios({
    url: skuEndPoints.getAllSkuSubCategoriesNotPaginated,
    method: "GET",
    params,
  });
};

export const getPriceListSkuNames = (params) => {
  return axios({
    url: skuEndPoints.getPriceListSkuNames,
    method: "GET",
    params,
  });
};
